import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EMPTY_CIRCUIT_ROOMING_LIST_EXPORT_CRITERIA, EMPTY_ROOMING_LIST_HISOTRY_CRITERIA } from "../constants/circuitRoomingListConstants";
import { CirctuitRoomingListState } from "../objects/circuitRoomingListState";
import { CircuitRoomingListExportCriteria } from "../objects/circuitRoomingListExportCriteria";
import { RoomingListGeneration } from "../objects/roomingListGeneration";
import { RoomingListParams } from "../../circuitRoomingListParams/objects/roomingListParams";
import { RoomingListHistory, RoominglistHistoryCriteria } from "../objects/roomingListHistory";

const initialState: CirctuitRoomingListState = {
    export_criteria: EMPTY_CIRCUIT_ROOMING_LIST_EXPORT_CRITERIA,
    circuit_ids: [],
    rooming_list_generation: [],
    rooming_list_generation_loaded: false,
    list_loading: false,
    selected_template: null,

    rooming_list_history: [],
    rooming_list_history_loaded: false,
    rooming_list_history_search: "",
    rooming_list_history_criteria: EMPTY_ROOMING_LIST_HISOTRY_CRITERIA,
};

const updateExportCriteriaReducer = (state: CirctuitRoomingListState, action: PayloadAction<CircuitRoomingListExportCriteria>): CirctuitRoomingListState => ({
    ...state, export_criteria: action.payload
});
const setListLoadingReducer = (state: CirctuitRoomingListState, action: PayloadAction<boolean>): CirctuitRoomingListState => ({
    ...state, list_loading: action.payload
});
const updateRoomingListGenerationReducer = (state: CirctuitRoomingListState, action: PayloadAction<RoomingListGeneration[]>): CirctuitRoomingListState => ({
    ...state, rooming_list_generation: action.payload, rooming_list_generation_loaded: true
});
const updateSelectedTemplateReducer = (state: CirctuitRoomingListState, action: PayloadAction<RoomingListParams | null>): CirctuitRoomingListState => ({
    ...state, selected_template: action.payload
});
const setCircuitIdsReducer = (state: CirctuitRoomingListState, action: PayloadAction<number[]>): CirctuitRoomingListState => ({
    ...state, circuit_ids: action.payload
});
const setRoomingListGenerationLoadedReducer = (state: CirctuitRoomingListState, action: PayloadAction<boolean>): CirctuitRoomingListState => ({
    ...state, rooming_list_generation_loaded: action.payload
});


// ------------------- rooming list history -------------------------- //
const setRoomingListHistoryReducer = (state: CirctuitRoomingListState, action: PayloadAction<RoomingListHistory[]>): CirctuitRoomingListState => ({
    ...state, rooming_list_history: action.payload, rooming_list_history_loaded: true
});
const setRoomingListHistoryCriteriaReducer = (state: CirctuitRoomingListState, action: PayloadAction<RoominglistHistoryCriteria>): CirctuitRoomingListState => ({
    ...state, rooming_list_history_criteria: action.payload
});
const setRoomingListHistorySearchReducer = (state: CirctuitRoomingListState, action: PayloadAction<string>): CirctuitRoomingListState => ({
    ...state, rooming_list_history_search: action.payload, rooming_list_history_criteria: {...state.rooming_list_history_criteria, page: 0}
});
const setRoomingListHistoryLoadedReducer = (state: CirctuitRoomingListState, action: PayloadAction<boolean>): CirctuitRoomingListState => ({
    ...state, rooming_list_history_loaded: action.payload
});

export const circuitRoomingListSlice = createSlice({
    name: 'circuit_rooming_list',
    initialState,
    reducers: {
        updateExportCriteria: updateExportCriteriaReducer,
        setListLoading: setListLoadingReducer,
        updateRoomingListGeneration: updateRoomingListGenerationReducer,
        updateSelectedTemplate: updateSelectedTemplateReducer,
        setCircuitIds: setCircuitIdsReducer,
        setRoomingListGenerationLoaded: setRoomingListGenerationLoadedReducer,

        setRoomingListHistory: setRoomingListHistoryReducer,
        setRoomingListHistoryCriteria: setRoomingListHistoryCriteriaReducer,
        setRoomingListHistorySearch: setRoomingListHistorySearchReducer,
        setRoomingListHistoryLoaded: setRoomingListHistoryLoadedReducer,
    }
});

export const {
    updateExportCriteria,
    setListLoading,
    updateRoomingListGeneration,
    updateSelectedTemplate,
    setCircuitIds,
    setRoomingListGenerationLoaded,

    setRoomingListHistory,
    setRoomingListHistoryCriteria,
    setRoomingListHistorySearch,
    setRoomingListHistoryLoaded
} = circuitRoomingListSlice.actions;

